// ChinesePage
import appCN from '../components/business/cn';
import cnHome from '../components/business/cn/cx_home';
import cnMain from '../components/business/cn/cx_main';
import cn_Products from '../components/business/cn/cx_product';
import cn_IndustryNews from '../components/business/cn/cx_industrynews';
import cn_ContactUs from '../components/business/cn/cx_contactus';

// EnglishPage
import appEN from '../components/business/en';
import enHome from '../components/business/en/cx_home';
import enMain from '../components/business/en/cx_main';
import en_Products from '../components/business/en/cx_product';
import en_IndustryNews from '../components/business/en/cx_industrynews';
import en_ContactUs from '../components/business/en/cx_contactus';


// ManagePage
import mgLogin from '../components/manage/cx_login';
import mgMain from '../components/manage/cx_main';

const routes = [
    {
        path: '/',
        redirect: '/cn',
        key: "menu_1",
        hidden: true,
        meta: {
            title:'舟山辰熙新材料有限公司'
        }
    },
    {
        path: '/cn',
        component: appCN,
        key: "menu_cn_1",
        meta: {
            title:'舟山辰熙新材料有限公司'
        },
        children: [
            {
                path: '/cn/cn_Home',
                name: '/cn/cn_home',
                component: cnHome,
                key: "menu_cn_1_1",
                meta: {
                    title:'首页'
                }
            },
            {
                path: '/cn/cn_Main',
                name: '/cn/cn_main',
                component: cnMain,
                key: "menu_cn_1_2",
                meta: {
                    title:'公司简介'
                }
            },
            {
                path: '/cn/cn_Products',
                name: '/cn/cn_Products',
                component: cn_Products,
                key: "menu_cn_1_3",
                meta: {
                    title:'产品介绍'
                }
            },
            {
                path: '/cn/cn_IndustryNews',
                name: '/cn/cn_IndustryNews',
                component: cn_IndustryNews,
                key: "menu_cn_1_4",
                meta: {
                    title:'行业动态'
                }
            },
            {
                path: '/cn/cn_ContactUs',
                name: '/cn/cn_ContactUs',
                component: cn_ContactUs,
                key: "menu_cn_1_5",
                meta: {
                    title:'联系我们'
                }
            }
        ]
    },
    {
        path: '/en',
        component: appEN,
        key: "menu_en_1",
        meta: {
            title:'Zhoushan Chenxi New Material Co., Ltd.'
        },
        children: [
            {
                path: '/en/en_Home',
                name: '/en/en_home',
                component: enHome,
                key: "menu_en_1_1",
                meta: {
                    title:'Home Page'
                }
            },
            {
                path: '/en/en_Main',
                name: '/en/en_main',
                component: enMain,
                key: "menu_en_1_2",
                meta: {
                    title:'Company Information'
                }
            },
            {
                path: '/en/en_Products',
                name: '/en/en_Products',
                component: en_Products,
                key: "menu_en_1_3",
                meta: {
                    title:'Product'
                }
            },
            {
                path: '/en/en_IndustryNews',
                name: '/en/en_IndustryNews',
                component: en_IndustryNews,
                key: "menu_en_1_4",
                meta: {
                    title:'Industry News'
                }
            },
            {
                path: '/en/en_ContactUs',
                name: '/en/en_ContactUs',
                component: en_ContactUs,
                key: "menu_en_1_5",
                meta: {
                    title:'Contact us'
                }
            }
        ]
    },
    {
        path: '/manage',
        key: "login_cn_1",
        meta: {
            title:'Manage'
        },
        children: [
            {
                path: '/manage/mg_Login',
                name: '/manage/mg_login',
                key: "login_cn_1_1",
                component: mgLogin,
                meta: {
                    title:'Login'
                }
            },{
                path: '/manage/mg_main',
                name: '/manage/mg_main',
                key: "login_cn_1_2",
                component: mgMain,
                meta: {
                    title:'Main'
                }
            }
        ]
        
    },
]

export default routes;